module.exports = __webpack_public_path__ + "static/media/blobs-dt-en.7c47b92d.png";